/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListUsers200ResponseLinks } from './ListUsers200ResponseLinks';
import {
    ListUsers200ResponseLinksFromJSON,
    ListUsers200ResponseLinksFromJSONTyped,
    ListUsers200ResponseLinksToJSON,
    ListUsers200ResponseLinksToJSONTyped,
} from './ListUsers200ResponseLinks';
import type { ListUsers200ResponseMeta } from './ListUsers200ResponseMeta';
import {
    ListUsers200ResponseMetaFromJSON,
    ListUsers200ResponseMetaFromJSONTyped,
    ListUsers200ResponseMetaToJSON,
    ListUsers200ResponseMetaToJSONTyped,
} from './ListUsers200ResponseMeta';
import type { ShowThread200ResponseDataUser } from './ShowThread200ResponseDataUser';
import {
    ShowThread200ResponseDataUserFromJSON,
    ShowThread200ResponseDataUserFromJSONTyped,
    ShowThread200ResponseDataUserToJSON,
    ShowThread200ResponseDataUserToJSONTyped,
} from './ShowThread200ResponseDataUser';

/**
 * 
 * @export
 * @interface ListUsers200Response
 */
export interface ListUsers200Response {
    /**
     * 
     * @type {Array<ShowThread200ResponseDataUser>}
     * @memberof ListUsers200Response
     */
    data?: Array<ShowThread200ResponseDataUser>;
    /**
     * 
     * @type {ListUsers200ResponseLinks}
     * @memberof ListUsers200Response
     */
    links?: ListUsers200ResponseLinks;
    /**
     * 
     * @type {ListUsers200ResponseMeta}
     * @memberof ListUsers200Response
     */
    meta?: ListUsers200ResponseMeta;
}

/**
 * Check if a given object implements the ListUsers200Response interface.
 */
export function instanceOfListUsers200Response(value: object): value is ListUsers200Response {
    return true;
}

export function ListUsers200ResponseFromJSON(json: any): ListUsers200Response {
    return ListUsers200ResponseFromJSONTyped(json, false);
}

export function ListUsers200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListUsers200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ShowThread200ResponseDataUserFromJSON)),
        'links': json['links'] == null ? undefined : ListUsers200ResponseLinksFromJSON(json['links']),
        'meta': json['meta'] == null ? undefined : ListUsers200ResponseMetaFromJSON(json['meta']),
    };
}

export function ListUsers200ResponseToJSON(json: any): ListUsers200Response {
    return ListUsers200ResponseToJSONTyped(json, false);
}

export function ListUsers200ResponseToJSONTyped(value?: ListUsers200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ShowThread200ResponseDataUserToJSON)),
        'links': ListUsers200ResponseLinksToJSON(value['links']),
        'meta': ListUsers200ResponseMetaToJSON(value['meta']),
    };
}

